import api from "../../services/api";

export default class BRyHUB {
    static async authorize({ id = null, table = null }) {
        try {
            let body = { signData: `${id}${table}`, };

            const response = await api.post("/bry/user/sign-cloud", body);

            let { error, authorize_url } = response.data;

            if (!error && authorize_url) {
                setTimeout(() => {
                    window.open(authorize_url, "_blank");
                }, 1500);
            }
        } catch (error) {
            console.log(error);
        }
    }
}